import {Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useSalesOrganization} from '../../../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'

export const SelectSalesOrg = () => {
  const {t} = useTranslation()
  const {salesOrgOptions} = useSalesOrganization()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  const handleChange = (value: string) => {
    dispatch(setJbpDetail({...jbp, sales_org_code: value}))
  }

  return (
    <Form.Group controlId='select-sales-org'>
      <Form.Label>{t('sub-order-produsen')}</Form.Label>
      <Form.Select
        value={jbp?.sales_org_code ?? ''}
        onChange={({target}) => handleChange(target.value)}
      >
        {salesOrgOptions?.map((item, index) => (
          <option key={item?.value ?? index} value={item.value}>
            {item.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  )
}
